// extracted by mini-css-extract-plugin
export var hideEditor = "_kv-2";
export var infoIcon = "_kv-3";
export var label = "_kv-1";
export var labelContainer = "_kv-0";
export var readonlyText = "_kv-4";